import { useCallback, useEffect, useState } from "react";
import { fetchRewardPage } from "../lib/reward-api";
import { getApiErrorMessage } from "../lib/api";

const emptyCatalog = { itens: [], total: 0, pagina: 1, limite: 24, paginas: 1, categorias: [] };

export function useRewardCatalog({ admin = false, search = "", category = "", enabled = true } = {}) {
  const [query, setQuery] = useState({ busca: "", categoria: "", pagina: 1 });
  const [catalog, setCatalog] = useState(emptyCatalog);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision((value) => value + 1), []);
  const setPage = useCallback((pagina) => setQuery((current) => ({ ...current, pagina })), []);

  useEffect(() => {
    const timer = setTimeout(() => setQuery((current) => current.busca === search.trim() && current.categoria === category
      ? current : { busca: search.trim(), categoria: category, pagina: 1 }), search.trim() !== query.busca ? 300 : 0);
    return () => clearTimeout(timer);
  }, [search, category, query.busca]);

  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setLoading(true);
    setError("");
    fetchRewardPage({ ...query, limite: 24, incluir_inativas_erp: admin }, { signal: controller.signal })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        if (query.pagina > data.paginas) setPage(data.paginas);
        else setCatalog(data);
      })
      .catch((failure) => {
        if (!controller.signal.aborted) setError(getApiErrorMessage(failure, "Erro ao carregar o catálogo."));
      })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [query, revision, admin, enabled, setPage]);

  return { ...catalog, loading: loading || search.trim() !== query.busca || category !== query.categoria, error, refresh, setPage };
}
